// "1 mile", "3 miles": every noun counted here takes a plain "s".
export const count = (n: number, noun: string) => `${n} ${noun}${n === 1 ? '' : 's'}`;
